import { Action, AgentType, Message, MessageType } from '@/api/rest/resources/types/conversation';

export const ASK_VA_ACTIONS: Action[] = [
  {
    id: `${AgentType.copilot}:ask_va`,
    name: 'Ask Va',
    description: 'Ask a question to Va',
    context: {
      action_type: 'text_input',
    },
  },
];

// TODO: MVP-VA lokalise when other languages are supported
// Note: these are not actions picked from the backend, they are generic first questions
// (id/name/description) that we want to show for the user to start the conversation with Va.
const DEFAULT_ACTIONS: Action[] = [
  {
    id: 'organization:get_organization_summary',
    name: 'How is my organization doing?',
    description: 'Get a summary of the organization',
  },
  {
    id: 'plot_aggregate_facts:get_reporting_facts_for_plots',
    name: 'What risks do I have?',
    description: 'Summarize the risks of the organization based on latest data',
  },
  {
    id: 'roadmap:get_organization_roadmaps',
    name: 'What are my next steps?',
    description: 'Get the roadmaps of the organization',
  },
];

export const DEFAULT_GREETING_MESSAGE: Partial<Message> = {
  content: "Hi, I'm Va! Your AI Copilot. How can I help you today?",
  is_user: false,
  context: {
    type: MessageType.BUFFERED,
    actions: DEFAULT_ACTIONS,
  },
};
